export const dateFormatter = new Intl.DateTimeFormat(navigator.language || 'en-US');
export const timeStampFormatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
    timeStyle: "medium",
    dateStyle: "short",
});
